import { render, staticRenderFns } from "./BpSwitch.vue?vue&type=template&id=ebfda148&scoped=true&"
import script from "./BpSwitch.vue?vue&type=script&lang=js&"
export * from "./BpSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BpSwitch.vue?vue&type=style&index=0&id=ebfda148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfda148",
  null
  
)

export default component.exports